import { Box, Typography } from '@mui/material';

function RateEventWarning() {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" px={1} py={4}>
      <Typography textAlign="center" fontSize={20} fontWeight={500}>
        There are existing events that fall outside the updated <br /> start date and duration.
      </Typography>
    </Box>
  );
}
export default RateEventWarning;
